import { useState, useEffect } from "react";
import { GeneralFooter, MooringMateHomeHeader } from "../../../components";
import "./ForgotPassword.css";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import { forgotPassword } from "../../../services/auth";
import toast from "react-hot-toast";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const res = await forgotPassword(email);

    if (res.status) {
      toast.success(res.message);
      setMinutes(2);
      setSeconds(59);
      setLoading(false);
      return;
    }

    toast.error(res.message);
    setLoading(false);
    return;
  };

  return (
    <>
      <MooringMateHomeHeader />
      <div className="reset-wrapper top-section">
        <Container maxWidth="xl">
          <div className="reset-password-content">
            <h1 className="title">Reset your password</h1>
            <form onSubmit={handleSubmit} className="formInputContainer">
              <TextField
                required
                name="email"
                label="Enter your email"
                type="email"
                size="small"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button
                fullWidth
                type="submit"
                variant="contained"
                color="primary"
                className="theme-btn"
                disabled={seconds > 0 || minutes > 0 || loading}
                loading={loading}
                loadingPosition="end"
                sx={{
                  boxShadow: "0 0px 0px 0px rgba(255, 255, 255, .0)!important",
                  height: "50px",
                  borderRadius: "10px",
                }}
              >
                Send Email
              </Button>
              <p className={seconds === 0 && minutes === 0 ? "hide" : ""}>
                Didn't get the password reset mail? send again in{" "}
                {minutes < 10 ? `0${minutes}` : minutes}:
                {seconds < 10 ? `0${seconds}` : seconds} minutes.
              </p>
            </form>
          </div>
        </Container>
      </div>
      {/* footer */}
      <GeneralFooter />
    </>
  );
};
